// src/components/common/FormControl/IconLink/index.jsx

import clsx from "clsx";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    minWidth: "unset",
    color: theme.palette.common.blue,
    marginRight: 6,
    "&:hover": {
      backgroundColor: "transparent",
      opacity: "0.7",
    },
  },
  icon: {
    fontSize: 12,
    width: "unset",
    height: "unset",
    overflow: "unset",
  },
  btnText: {
    fontSize: 12,
  },
}));

const IconLink = ({
  icon,
  onClick,
  customClass,
  customTextClass,
  text,
  title,
  placement,
  disabled,
  sx = {},
}) => {
  const classes = useStyles();

  return (
    <Tooltip title={title} placement={placement}>
      <IconButton
        className={classes.root}
        onClick={onClick}
        disabled={disabled}
        sx={sx.root}
      >
        <Icon
          className={clsx(icon, customClass, classes.icon)}
          sx={sx.icon}
        />
        <Box
          component="span"
          className={clsx(customTextClass, classes.btnText)}
          sx={sx.text}
        >
          {text}
        </Box>
      </IconButton>
    </Tooltip>
  );
};

IconLink.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.node,
  title: PropTypes.node,
  placement: PropTypes.string,
  disabled: PropTypes.bool,
  customClass: PropTypes.string,
  customTextClass: PropTypes.string,
  sx: PropTypes.shape({
    root: PropTypes.object,
    icon: PropTypes.object,
    text: PropTypes.object,
  }),
};

IconLink.displayName = "IconLink";

export default IconLink;
